<template>
  <div id="resumo-proposta">
    <v-row>
      <v-col cols="12" class="py-0 grey--text text--darken-3 font-weight-medium">
        <resumo-cliente-dados-gerais :model="model"></resumo-cliente-dados-gerais>
        <br/>
        <v-card>
          <v-card-title class="text-center justify-center align-center">
            {{ model.QtdeParcelas }}x de R$ {{ $api.UI.Format.Decimal(model.VlrParcelaCalculado ) }}
          </v-card-title>

          <v-divider />

          <v-card-text class="text-body-2">
            <v-row class="ma-2">
              <span> Valor Solicitado: </span>
              <span class="ml-auto"> R$ {{ $api.UI.Format.Decimal(model.VlrSolicitado) }} </span>
            </v-row>
            <v-row class="ma-2">
              <span> Valor IOF: </span>
              <span class="ml-auto"> R$ {{$api.UI.Format.Decimal(model.VlrIOF)}}  </span>
            </v-row>
            <v-row class="ma-2">
              <span> Valor Tarifa Cadastral:  </span>
              <span class="ml-auto"> R$ {{$api.UI.Format.Decimal(model.VlrTAC)}} </span>
            </v-row>

          <v-divider />

            <v-row class="ma-2 font-weight-bold">
              <span> Valor Financiado: </span>
              <span class="ml-auto">  R$ {{$api.UI.Format.Decimal(model.VlrTotalCredito)}}  </span>
            </v-row>
            <v-row class="ma-2">
              <span> Valor do Juros: </span>
              <div class="text-right ml-auto ">
                <span>  R$ {{$api.UI.Format.Decimal(model.VlrTotalDivida - model.VlrTotalCredito)}} </span>
                <div class="text-caption"> {{$api.UI.Format.Decimal(model.PercJurosMensal)}}% a.m. / {{$api.UI.Format.Decimal(model.PercJurosAnual)}}% a.a. </div>
              </div>
            </v-row>

          <v-divider />

            <v-row class="ma-2 font-weight-bold">
              <span> Valor total a pagar: </span>
              <span class="ml-auto"> R$ {{ $api.UI.Format.Decimal(model.VlrTotalDivida) }} </span>
            </v-row>
            <v-row class="ma-2">
              <span> Valor Custo Efetivo Total (CET): </span>
              <span class=" ml-auto ">  {{$api.UI.Format.Decimal(model.PercCETMensal)}}% a.m. / {{$api.UI.Format.Decimal(model.PercCETAnual)}}% a.a. </span>
            </v-row>
            <v-row class="ma-2 font-weight-bold">
              <span> Primeiro Vencimento: </span>
              <span class="ml-auto"> {{ $api.UI.Format.Date(model.DtPrimeiroVencto) }} </span>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  props: {
    modal: { type: Boolean, default: false },
    model: { type: Object }
  },
  data () {
    return {
      isLoaded: false,
    };
  },
  methods: {
    load (model) {
      this.$api.UTIL.Functions.SetAllButNull(this, this, 'model', model);
      this.isLoaded = true;
    },
  },
};
</script>

<style>
#resumo-proposta span.text-label {
  display: block;
  font-weight: 400;
}

#resumo-proposta span.text-h5 {
  font-weight: 400;
}

#resumo-proposta div.item-value {
  padding-bottom: 2px;
  padding-top: 2px;
  padding-left: 12px;
  padding-right: 12px;
  display: flex;
  justify-content: space-between;
}

#resumo-proposta span.text-value-label,
#resumo-proposta span.text-subtitle-1 {
  font-weight: 400;
}

#resumo-proposta span.text-value {
  text-align: end;
}
</style>
